import {TreeViewBaseItem} from '@mui/x-tree-view';
import {ExtendedTreeItemProps} from '../../shared/interfaces';
import {IGetBulkTagResponse} from '../../api/types/assignment.type';

const labelToName = (label: string): string => {
  return label.toLowerCase().replace(/\s+/g, '_');
};

const getFileType = (type: string | undefined, isGroup: boolean) => {
  if (type?.includes('tag') && isGroup) {
    return 'tag';
  } else if (isGroup) {
    return 'folder';
  }
  return '';
};

export const transformJsTreeApiToTreeData = (
  apiResponse: IGetBulkTagResponse | undefined | null
): TreeViewBaseItem<ExtendedTreeItemProps>[] => {
  if (!apiResponse || !Array.isArray(apiResponse.jsTreeData)) return [];
  const flatTreeData = apiResponse.jsTreeData;
  const nodeMap = new Map<string, TreeViewBaseItem<ExtendedTreeItemProps>>();
  const rootNodes: TreeViewBaseItem<ExtendedTreeItemProps>[] = [];

  flatTreeData.forEach((item) => {
    if (item?.id == null) {
      return;
    }

    const label = item.text || `Node ${item.id}`;
    const name = labelToName(label);
    const fileType = getFileType(item.type, item.isGroup);

    const node: TreeViewBaseItem<ExtendedTreeItemProps> = {
      id: String(item.id),
      label,
      name,
      fileType,
      hasChildren: false,
      isChildrenLoaded: false,
      type: item.type,
      isGroup: item.isGroup === true,
    };

    nodeMap.set(String(item.id), node);
  });

  flatTreeData.forEach((item) => {
    if (item?.id == null) return;

    const nodeId = String(item.id);
    const node = nodeMap.get(nodeId);
    if (!node) return;

    const parentId = String(item.parent);
    const isRoot =
      !parentId ||
      parentId === '#' ||
      ['null', 'undefined', ''].includes(parentId);

    if (isRoot) {
      rootNodes.push(node);
    } else {
      const parent = nodeMap.get(parentId);
      if (parent) {
        parent.children ??= [];
        parent.children.push(node);
      } else {
        rootNodes.push(node);
      }
    }
  });

  const modifyTreeData = (
    nodes: TreeViewBaseItem<ExtendedTreeItemProps>[],
    parentNode?: TreeViewBaseItem<ExtendedTreeItemProps>
  ): TreeViewBaseItem<ExtendedTreeItemProps>[] => {
    return nodes.map((node) => {
      const hasChildren = !!(node.children && node.children.length > 0);
      const modifiedNode: TreeViewBaseItem<ExtendedTreeItemProps> = {
        ...node,
        hasChildren,
        isChildrenLoaded: hasChildren,
        ...(parentNode && {
          fieldId: parentNode.id,
          parentFolder: parentNode.label,
          parentTagName: parentNode.name || labelToName(parentNode.label),
        }),
      };

      if (hasChildren) {
        modifiedNode.children = modifyTreeData(node.children!, modifiedNode);
      }

      return modifiedNode;
    });
  };

  return modifyTreeData(rootNodes);
};
